import { gql } from '@apollo/client';

export const ROLE_PRIVILEGES = gql`
  query RolePrivileges {
    rolePrivileges {
      id
      role
      privilegeKey
      grantedAt
      grantedByUserId
    }
  }
`;

export const MY_PRIVILEGES = gql`
  query MyPrivileges {
    myPrivileges
  }
`;

export const SET_ROLE_PRIVILEGE = gql`
  mutation SetRolePrivilege($input: SetRolePrivilegeInput!) {
    setRolePrivilege(input: $input)
  }
`;
